import { useMutation, useQueryClient } from "@tanstack/react-query";
import { initiateMRDC } from "@/api/v1-jwt/mrdc/mrdc";

export const useInitiateMRDC = () => {
  const query = useQueryClient();

  return useMutation({
    mutationFn: async ({ invoiceId, ...payload }) =>
      await initiateMRDC({ invoiceId, payload }),
    onSuccess: () => {
      query.invalidateQueries(["mrdc"]);
    },
  });
};
